import "lazysizes";
import Vue from "vue";
import LazyImg from "@/components/LazyImg.vue";

Vue.component(LazyImg.name, LazyImg);
